export const USER_ROLES = {
  OWNER: 'Owner',
  VIEWER: 'Viewer',
} as const

export type UserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES]

export type User = {
  userId: number
  name: string
  email: string
  domains?: Array<string>
  invitation: boolean
  invitationId?: number
  role: UserRoles
}
